/**
 * Canonical region picks (stored in onboarding as English `pick` labels).
 * `key` must match public.regions.region_key when Supabase is used.
 */
export const REGION_CITY_ROWS = [

  // ─── 🇻🇳 베트남 ───────────────────────────────────────────
  { pick: 'Da Nang',     key: 'danang',     ko: '다낭',       country: 'VN', popular: true,  open: true  },
  { pick: 'Ho Chi Minh', key: 'hochiminh',  ko: '호치민',     country: 'VN', popular: true,  open: false },
  { pick: 'Hanoi',       key: 'hanoi',      ko: '하노이',     country: 'VN', popular: true,  open: false },
  { pick: 'Hoi An',      key: 'hoian',      ko: '호이안',     country: 'VN', popular: false, open: false },
  { pick: 'Nha Trang',   key: 'nhatrang',   ko: '나트랑',     country: 'VN', popular: false, open: false },
  { pick: 'Da Lat',      key: 'dalat',      ko: '달랏',       country: 'VN', popular: false, open: false },
  { pick: 'Hue',         key: 'hue',        ko: '훼',         country: 'VN', popular: false, open: false },
  { pick: 'Vung Tau',    key: 'vungtau',    ko: '붕따우',     country: 'VN', popular: false, open: false },
  { pick: 'Phu Quoc',    key: 'phuquoc',    ko: '푸꾸옥',     country: 'VN', popular: false, open: false },
  { pick: 'Hai Phong',   key: 'haiphong',   ko: '하이퐁',     country: 'VN', popular: false, open: false },
  { pick: 'Bac Ninh',    key: 'bacninh',    ko: '박닌',       country: 'VN', popular: false, open: false },
  { pick: 'Binh Duong',  key: 'binhduong',  ko: '빈즈엉',     country: 'VN', popular: false, open: false },
  { pick: 'Dong Nai',    key: 'dongnai',    ko: '동나이',     country: 'VN', popular: false, open: false },
  { pick: 'Can Tho',     key: 'cantho',     ko: '껀터',       country: 'VN', popular: false, open: false },
  { pick: 'Quang Ninh',  key: 'quangninh',  ko: '꽝닌',       country: 'VN', popular: false, open: false },
  { pick: 'Vinh',        key: 'vinh',       ko: '빈',         country: 'VN', popular: false, open: false },

  // ─── 🇰🇷 한국 ───────────────────────────────────────────
  { pick: 'Seoul',       key: 'seoul',      ko: '서울',       country: 'KR', popular: true,  open: true  },
  { pick: 'Busan',       key: 'busan',      ko: '부산',       country: 'KR', popular: true,  open: true  },
  { pick: 'Incheon',     key: 'incheon',    ko: '인천',       country: 'KR', popular: false, open: true  },
  { pick: 'Jeju',        key: 'jeju',       ko: '제주',       country: 'KR', popular: false, open: true  },
  { pick: 'Daegu',       key: 'daegu',      ko: '대구',       country: 'KR', popular: false, open: true  },
  { pick: 'Daejeon',     key: 'daejeon',    ko: '대전',       country: 'KR', popular: false, open: true  },
  { pick: 'Gwangju',     key: 'gwangju',    ko: '광주',       country: 'KR', popular: false, open: true  },
  { pick: 'Ulsan',       key: 'ulsan',      ko: '울산',       country: 'KR', popular: false, open: true  },
  { pick: 'Suwon',       key: 'suwon',      ko: '수원',       country: 'KR', popular: false, open: true  },
  { pick: 'Seongnam',    key: 'seongnam',   ko: '성남',       country: 'KR', popular: false, open: true  },
  { pick: 'Goyang',      key: 'goyang',     ko: '고양',       country: 'KR', popular: false, open: true  },
  { pick: 'Changwon',    key: 'changwon',   ko: '창원',       country: 'KR', popular: false, open: true  },
  { pick: 'Jeonju',      key: 'jeonju',     ko: '전주',       country: 'KR', popular: false, open: true  },
  { pick: 'Cheongju',    key: 'cheongju',   ko: '청주',       country: 'KR', popular: false, open: true  },
  { pick: 'Ansan',       key: 'ansan',      ko: '안산',       country: 'KR', popular: false, open: true  },
  { pick: 'Yongin',      key: 'yongin',     ko: '용인',       country: 'KR', popular: false, open: true  },
  { pick: 'Pyeongtaek',  key: 'pyeongtaek', ko: '평택',       country: 'KR', popular: false, open: true  },
  { pick: 'Cheonan',     key: 'cheonan',    ko: '천안',       country: 'KR', popular: false, open: true  },
  { pick: 'Pohang',      key: 'pohang',     ko: '포항',       country: 'KR', popular: false, open: true  },
  { pick: 'Gimhae',      key: 'gimhae',     ko: '김해',       country: 'KR', popular: false, open: true  },
  { pick: 'Gimpo',       key: 'gimpo',      ko: '김포',       country: 'KR', popular: false, open: true  },
  { pick: 'Hwaseong',    key: 'hwaseong',   ko: '화성',       country: 'KR', popular: false, open: true  },
  { pick: 'Namyangju',   key: 'namyangju',  ko: '남양주',     country: 'KR', popular: false, open: true  },
  { pick: 'Bucheon',     key: 'bucheon',    ko: '부천',       country: 'KR', popular: false, open: true  },
  { pick: 'Uijeongbu',   key: 'uijeongbu',  ko: '의정부',     country: 'KR', popular: false, open: true  },
  { pick: 'Gumi',        key: 'gumi',       ko: '구미',       country: 'KR', popular: false, open: true  },

  // ─── 🇯🇵 일본 ───────────────────────────────────────────
  { pick: 'Tokyo',       key: 'tokyo',      ko: '도쿄',       country: 'JP', popular: true,  open: false },
  { pick: 'Osaka',       key: 'osaka',      ko: '오사카',     country: 'JP', popular: true,  open: false },
  { pick: 'Fukuoka',     key: 'fukuoka',    ko: '후쿠오카',   country: 'JP', popular: false, open: false },
  { pick: 'Nagoya',      key: 'nagoya',     ko: '나고야',     country: 'JP', popular: false, open: false },
  { pick: 'Sapporo',     key: 'sapporo',    ko: '삿포로',     country: 'JP', popular: false, open: false },
  { pick: 'Kyoto',       key: 'kyoto',      ko: '교토',       country: 'JP', popular: false, open: false },
  { pick: 'Yokohama',    key: 'yokohama',   ko: '요코하마',   country: 'JP', popular: false, open: false },
  { pick: 'Kobe',        key: 'kobe',       ko: '고베',       country: 'JP', popular: false, open: false },
  { pick: 'Hiroshima',   key: 'hiroshima',  ko: '히로시마',   country: 'JP', popular: false, open: false },
  { pick: 'Sendai',      key: 'sendai',     ko: '센다이',     country: 'JP', popular: false, open: false },
  { pick: 'Okinawa',     key: 'okinawa',    ko: '오키나와',   country: 'JP', popular: false, open: false },

  // ─── 🇨🇳 중국 ───────────────────────────────────────────
  { pick: 'Shanghai',    key: 'shanghai',   ko: '상하이',     country: 'CN', popular: true,  open: false },
  { pick: 'Beijing',     key: 'beijing',    ko: '베이징',     country: 'CN', popular: true,  open: false },
  { pick: 'Qingdao',     key: 'qingdao',    ko: '칭다오',     country: 'CN', popular: false, open: false },
  { pick: 'Guangzhou',   key: 'guangzhou',  ko: '광저우',     country: 'CN', popular: false, open: false },
  { pick: 'Shenzhen',    key: 'shenzhen',   ko: '선전',       country: 'CN', popular: false, open: false },
  { pick: 'Chengdu',     key: 'chengdu',    ko: '청두',       country: 'CN', popular: false, open: false },
  { pick: 'Suzhou',      key: 'suzhou',     ko: '쑤저우',     country: 'CN', popular: false, open: false },
  { pick: 'Wuhan',       key: 'wuhan',      ko: '우한',       country: 'CN', popular: false, open: false },
  { pick: 'Hangzhou',    key: 'hangzhou',   ko: '항저우',     country: 'CN', popular: false, open: false },
  { pick: 'Tianjin',     key: 'tianjin',    ko: '톈진',       country: 'CN', popular: false, open: false },
  { pick: 'Xian',        key: 'xian',       ko: '시안',       country: 'CN', popular: false, open: false },
  { pick: 'Dalian',      key: 'dalian',     ko: '다롄',       country: 'CN', popular: false, open: false },
  { pick: 'Shenyang',    key: 'shenyang',   ko: '선양',       country: 'CN', popular: false, open: false },
  { pick: 'Harbin',      key: 'harbin',     ko: '하얼빈',     country: 'CN', popular: false, open: false },
  { pick: 'Kunming',     key: 'kunming',    ko: '쿤밍',       country: 'CN', popular: false, open: false },

  // ─── 🇹🇼 대만 ───────────────────────────────────────────
  { pick: 'Taipei',      key: 'taipei',     ko: '타이베이',   country: 'TW', popular: false, open: false },
  { pick: 'Kaohsiung',   key: 'kaohsiung',  ko: '가오슝',     country: 'TW', popular: false, open: false },
  { pick: 'Taichung',    key: 'taichung',   ko: '타이중',     country: 'TW', popular: false, open: false },
  { pick: 'Tainan',      key: 'tainan',     ko: '타이난',     country: 'TW', popular: false, open: false },

  // ─── 🇹🇭 태국 ───────────────────────────────────────────
  { pick: 'Bangkok',     key: 'bangkok',    ko: '방콕',       country: 'TH', popular: true,  open: false },
  { pick: 'Pattaya',     key: 'pattaya',    ko: '파타야',     country: 'TH', popular: false, open: false },
  { pick: 'Chiang Mai',  key: 'chiangmai',  ko: '치앙마이',   country: 'TH', popular: false, open: false },
  { pick: 'Phuket',      key: 'phuket',     ko: '푸켓',       country: 'TH', popular: false, open: false },
  { pick: 'Koh Samui',   key: 'samui',      ko: '사무이',     country: 'TH', popular: false, open: false },
  { pick: 'Hua Hin',     key: 'huahin',     ko: '후아힌',     country: 'TH', popular: false, open: false },
  { pick: 'Chiang Rai',  key: 'chiangrai',  ko: '치앙라이',   country: 'TH', popular: false, open: false },

  // ─── 🇵🇭 필리핀 ───────────────────────────────────────────
  { pick: 'Manila',      key: 'manila',     ko: '마닐라',     country: 'PH', popular: true,  open: false },
  { pick: 'Cebu',        key: 'cebu',       ko: '세부',       country: 'PH', popular: false, open: false },
  { pick: 'Clark',       key: 'clark',      ko: '클락',       country: 'PH', popular: false, open: false },
  { pick: 'Boracay',     key: 'boracay',    ko: '보라카이',   country: 'PH', popular: false, open: false },
  { pick: 'Davao',       key: 'davao',      ko: '다바오',     country: 'PH', popular: false, open: false },
  { pick: 'Palawan',     key: 'palawan',    ko: '팔라완',     country: 'PH', popular: false, open: false },
  { pick: 'Subic Bay',   key: 'subicbay',   ko: '수빅베이',   country: 'PH', popular: false, open: false },

  // ─── 🇮🇩 인도네시아 ───────────────────────────────────────────
  { pick: 'Jakarta',     key: 'jakarta',    ko: '자카르타',   country: 'ID', popular: false, open: false },
  { pick: 'Bali',        key: 'bali',       ko: '발리',       country: 'ID', popular: true,  open: false },
  { pick: 'Surabaya',    key: 'surabaya',   ko: '수라바야',   country: 'ID', popular: false, open: false },
  { pick: 'Medan',       key: 'medan',      ko: '메단',       country: 'ID', popular: false, open: false },
  { pick: 'Bandung',     key: 'bandung',    ko: '반둥',       country: 'ID', popular: false, open: false },
  { pick: 'Batam',       key: 'batam',      ko: '바탐',       country: 'ID', popular: false, open: false },
  { pick: 'Lombok',      key: 'lombok',     ko: '롬복',       country: 'ID', popular: false, open: false },

  // ─── 🇲🇾 말레이시아 ───────────────────────────────────────────
  { pick: 'Kuala Lumpur',  key: 'kualalumpur',  ko: '쿠알라룸푸르', country: 'MY', popular: true,  open: false },
  { pick: 'Penang',        key: 'penang',       ko: '페낭',         country: 'MY', popular: false, open: false },
  { pick: 'Kota Kinabalu', key: 'kotakinabalu', ko: '코타키나발루', country: 'MY', popular: false, open: false },
  { pick: 'Johor Bahru',   key: 'johorbahru',   ko: '조호르바루',   country: 'MY', popular: false, open: false },
  { pick: 'Malacca',       key: 'malacca',      ko: '말라카',       country: 'MY', popular: false, open: false },
  { pick: 'Kuching',       key: 'kuching',      ko: '쿠칭',         country: 'MY', popular: false, open: false },

  // ─── 🇸🇬 싱가포르 ───────────────────────────────────────────
  { pick: 'Singapore',   key: 'singapore',  ko: '싱가포르',   country: 'SG', popular: true,  open: false },

  // ─── 🇦🇪 UAE ───────────────────────────────────────────
  { pick: 'Dubai',       key: 'dubai',      ko: '두바이',     country: 'AE', popular: true,  open: false },
  { pick: 'Abu Dhabi',   key: 'abudhabi',   ko: '아부다비',   country: 'AE', popular: false, open: false },
  { pick: 'Sharjah',     key: 'sharjah',    ko: '샤르자',     country: 'AE', popular: false, open: false },

  // ─── 🇸🇦 사우디아라비아 ───────────────────────────────────────────
  { pick: 'Riyadh',      key: 'riyadh',     ko: '리야드',     country: 'SA', popular: false, open: false },
  { pick: 'Jeddah',      key: 'jeddah',     ko: '제다',       country: 'SA', popular: false, open: false },

  // ─── 🇶🇦 카타르 ───────────────────────────────────────────
  { pick: 'Doha',        key: 'doha',       ko: '도하',       country: 'QA', popular: false, open: false },

  // ─── 🇰🇼 쿠웨이트 ───────────────────────────────────────────
  { pick: 'Kuwait City', key: 'kuwaitcity', ko: '쿠웨이트시티', country: 'KW', popular: false, open: false },

  // ─── 🇧🇭 바레인 ───────────────────────────────────────────
  { pick: 'Manama',      key: 'manama',     ko: '마나마',     country: 'BH', popular: false, open: false },

  // ─── 🇴🇲 오만 ───────────────────────────────────────────
  { pick: 'Muscat',      key: 'muscat',     ko: '무스카트',   country: 'OM', popular: false, open: false },

  // ─── 🇷🇺 러시아 ───────────────────────────────────────────
  { pick: 'Moscow',           key: 'moscow',      ko: '모스크바',       country: 'RU', popular: true,  open: false },
  { pick: 'Saint Petersburg', key: 'spb',         ko: '상트페테르부르크', country: 'RU', popular: false, open: false },
  { pick: 'Vladivostok',      key: 'vladivostok', ko: '블라디보스토크',  country: 'RU', popular: false, open: false },
  { pick: 'Novosibirsk',      key: 'novosibirsk', ko: '노보시비르스크',  country: 'RU', popular: false, open: false },
  { pick: 'Khabarovsk',       key: 'khabarovsk',  ko: '하바롭스크',     country: 'RU', popular: false, open: false },

  // ─── 🇰🇿 카자흐스탄 ───────────────────────────────────────────
  { pick: 'Almaty',      key: 'almaty',     ko: '알마티',     country: 'KZ', popular: true,  open: false },
  { pick: 'Astana',      key: 'astana',     ko: '아스타나',   country: 'KZ', popular: false, open: false },

  // ─── 🇺🇿 우즈베키스탄 ───────────────────────────────────────────
  { pick: 'Tashkent',    key: 'tashkent',   ko: '타슈켄트',   country: 'UZ', popular: false, open: false },
  { pick: 'Samarkand',   key: 'samarkand',  ko: '사마르칸트', country: 'UZ', popular: false, open: false },

  // ─── 🇲🇳 몽골 ───────────────────────────────────────────
  { pick: 'Ulaanbaatar', key: 'ulaanbaatar', ko: '울란바토르', country: 'MN', popular: false, open: false },

  // ─── 🇮🇳 인도 ───────────────────────────────────────────
  { pick: 'New Delhi',   key: 'newdelhi',   ko: '뉴델리',     country: 'IN', popular: false, open: false },
  { pick: 'Mumbai',      key: 'mumbai',     ko: '뭄바이',     country: 'IN', popular: false, open: false },
  { pick: 'Bangalore',   key: 'bangalore',  ko: '방갈로르',   country: 'IN', popular: false, open: false },
  { pick: 'Chennai',     key: 'chennai',    ko: '첸나이',     country: 'IN', popular: false, open: false },
  { pick: 'Kolkata',     key: 'kolkata',    ko: '콜카타',     country: 'IN', popular: false, open: false },
  { pick: 'Hyderabad',   key: 'hyderabad',  ko: '하이데라바드', country: 'IN', popular: false, open: false },

  // ─── 🇳🇵 네팔 ───────────────────────────────────────────
  { pick: 'Kathmandu',   key: 'kathmandu',  ko: '카트만두',   country: 'NP', popular: false, open: false },

  // ─── 🇱🇰 스리랑카 ───────────────────────────────────────────
  { pick: 'Colombo',     key: 'colombo',    ko: '콜롬보',     country: 'LK', popular: false, open: false },

  // ─── 🇰🇭 캄보디아 ───────────────────────────────────────────
  { pick: 'Phnom Penh',  key: 'phnompenh',  ko: '프놈펜',     country: 'KH', popular: false, open: false },
  { pick: 'Siem Reap',   key: 'siemreap',   ko: '시엠립',     country: 'KH', popular: false, open: false },

  // ─── 🇲🇲 미얀마 ───────────────────────────────────────────
  { pick: 'Yangon',      key: 'yangon',     ko: '양곤',       country: 'MM', popular: false, open: false },
  { pick: 'Mandalay',    key: 'mandalay',   ko: '만달레이',   country: 'MM', popular: false, open: false },

  // ─── 🇦🇺 호주 ───────────────────────────────────────────
  { pick: 'Sydney',      key: 'sydney',     ko: '시드니',     country: 'AU', popular: true,  open: false },
  { pick: 'Melbourne',   key: 'melbourne',  ko: '멜버른',     country: 'AU', popular: false, open: false },
  { pick: 'Brisbane',    key: 'brisbane',   ko: '브리즈번',   country: 'AU', popular: false, open: false },
  { pick: 'Perth',       key: 'perth',      ko: '퍼스',       country: 'AU', popular: false, open: false },
  { pick: 'Adelaide',    key: 'adelaide',   ko: '애들레이드', country: 'AU', popular: false, open: false },
  { pick: 'Gold Coast',  key: 'goldcoast',  ko: '골드코스트', country: 'AU', popular: false, open: false },

  // ─── 🇳🇿 뉴질랜드 ───────────────────────────────────────────
  { pick: 'Auckland',        key: 'auckland',       ko: '오클랜드',     country: 'NZ', popular: false, open: false },
  { pick: 'Christchurch',    key: 'christchurch',   ko: '크라이스트처치', country: 'NZ', popular: false, open: false },
  { pick: 'Wellington',      key: 'wellington',     ko: '웰링턴',       country: 'NZ', popular: false, open: false },

  // ─── 🇺🇸 미국 ───────────────────────────────────────────
  { pick: 'Los Angeles',    key: 'losangeles',   ko: '로스앤젤레스',   country: 'US', popular: true,  open: false },
  { pick: 'New York',       key: 'newyork',      ko: '뉴욕',           country: 'US', popular: true,  open: false },
  { pick: 'Seattle',        key: 'seattle',      ko: '시애틀',         country: 'US', popular: false, open: false },
  { pick: 'San Francisco',  key: 'sanfrancisco', ko: '샌프란시스코',   country: 'US', popular: false, open: false },
  { pick: 'Chicago',        key: 'chicago',      ko: '시카고',         country: 'US', popular: false, open: false },
  { pick: 'Dallas',         key: 'dallas',       ko: '달라스',         country: 'US', popular: false, open: false },
  { pick: 'Atlanta',        key: 'atlanta',      ko: '애틀란타',       country: 'US', popular: false, open: false },
  { pick: 'Washington DC',  key: 'washingtondc', ko: '워싱턴DC',       country: 'US', popular: false, open: false },
  { pick: 'Houston',        key: 'houston',      ko: '휴스턴',         country: 'US', popular: false, open: false },
  { pick: 'Las Vegas',      key: 'lasvegas',     ko: '라스베이거스',   country: 'US', popular: false, open: false },
  { pick: 'Honolulu',       key: 'honolulu',     ko: '호놀룰루',       country: 'US', popular: false, open: false },
  { pick: 'San Diego',      key: 'sandiego',     ko: '샌디에이고',     country: 'US', popular: false, open: false },
  { pick: 'Boston',         key: 'boston',       ko: '보스턴',         country: 'US', popular: false, open: false },
  { pick: 'New Jersey',     key: 'newjersey',    ko: '뉴저지',         country: 'US', popular: false, open: false },
  { pick: 'Virginia',       key: 'virginia',     ko: '버지니아',       country: 'US', popular: false, open: false },

  // ─── 🇬🇺 괌 (미국령 → 별도 분리) ───────────────────────────────
  { pick: 'Guam',        key: 'guam',       ko: '괌',         country: 'GU', popular: false, open: false },

  // ─── 🇲🇵 사이판 (CNMI → 별도 분리) ─────────────────────────────
  { pick: 'Saipan',      key: 'saipan',     ko: '사이판',     country: 'MP', popular: false, open: false },

  // ─── 🇨🇦 캐나다 ───────────────────────────────────────────
  { pick: 'Vancouver',   key: 'vancouver',  ko: '밴쿠버',     country: 'CA', popular: true,  open: false },
  { pick: 'Toronto',     key: 'toronto',    ko: '토론토',     country: 'CA', popular: false, open: false },
  { pick: 'Calgary',     key: 'calgary',    ko: '캘거리',     country: 'CA', popular: false, open: false },
  { pick: 'Montreal',    key: 'montreal',   ko: '몬트리올',   country: 'CA', popular: false, open: false },
  { pick: 'Edmonton',    key: 'edmonton',   ko: '에드먼턴',   country: 'CA', popular: false, open: false },

  // ─── 🇬🇧 영국 ───────────────────────────────────────────
  { pick: 'London',      key: 'london',     ko: '런던',       country: 'GB', popular: true,  open: false },
  { pick: 'Manchester',  key: 'manchester', ko: '맨체스터',   country: 'GB', popular: false, open: false },
  { pick: 'Birmingham',  key: 'birmingham', ko: '버밍엄',     country: 'GB', popular: false, open: false },
  { pick: 'Edinburgh',   key: 'edinburgh',  ko: '에든버러',   country: 'GB', popular: false, open: false },

  // ─── 🇩🇪 독일 ───────────────────────────────────────────
  { pick: 'Frankfurt',   key: 'frankfurt',  ko: '프랑크푸르트', country: 'DE', popular: false, open: false },
  { pick: 'Berlin',      key: 'berlin',     ko: '베를린',     country: 'DE', popular: false, open: false },
  { pick: 'Munich',      key: 'munich',     ko: '뮌헨',       country: 'DE', popular: false, open: false },
  { pick: 'Hamburg',     key: 'hamburg',    ko: '함부르크',   country: 'DE', popular: false, open: false },
  { pick: 'Dusseldorf',  key: 'dusseldorf', ko: '뒤셀도르프', country: 'DE', popular: false, open: false },

  // ─── 🇫🇷 프랑스 ───────────────────────────────────────────
  { pick: 'Paris',       key: 'paris',      ko: '파리',       country: 'FR', popular: false, open: false },
  { pick: 'Lyon',        key: 'lyon',       ko: '리옹',       country: 'FR', popular: false, open: false },

  // ─── 🇳🇱 네덜란드 ───────────────────────────────────────────
  { pick: 'Amsterdam',   key: 'amsterdam',  ko: '암스테르담', country: 'NL', popular: false, open: false },

  // ─── 🇪🇸 스페인 ───────────────────────────────────────────
  { pick: 'Madrid',      key: 'madrid',     ko: '마드리드',   country: 'ES', popular: false, open: false },
  { pick: 'Barcelona',   key: 'barcelona',  ko: '바르셀로나', country: 'ES', popular: false, open: false },

  // ─── 🇮🇹 이탈리아 ───────────────────────────────────────────
  { pick: 'Rome',        key: 'rome',       ko: '로마',       country: 'IT', popular: false, open: false },
  { pick: 'Milan',       key: 'milan',      ko: '밀라노',     country: 'IT', popular: false, open: false },

  // ─── 🇵🇹 포르투갈 ───────────────────────────────────────────
  { pick: 'Lisbon',      key: 'lisbon',     ko: '리스본',     country: 'PT', popular: false, open: false },

  // ─── 🇵🇱 폴란드 ───────────────────────────────────────────
  { pick: 'Warsaw',      key: 'warsaw',     ko: '바르샤바',   country: 'PL', popular: false, open: false },

  // ─── 🇨🇿 체코 ───────────────────────────────────────────
  { pick: 'Prague',      key: 'prague',     ko: '프라하',     country: 'CZ', popular: false, open: false },

  // ─── 🇹🇷 터키 ───────────────────────────────────────────
  { pick: 'Istanbul',    key: 'istanbul',   ko: '이스탄불',   country: 'TR', popular: false, open: false },
  { pick: 'Ankara',      key: 'ankara',     ko: '앙카라',     country: 'TR', popular: false, open: false },

  // ─── 🇿🇦 남아프리카 ───────────────────────────────────────────
  { pick: 'Johannesburg', key: 'johannesburg', ko: '요하네스버그', country: 'ZA', popular: false, open: false },
  { pick: 'Cape Town',    key: 'capetown',     ko: '케이프타운',   country: 'ZA', popular: false, open: false },

  // ─── 🇪🇬 이집트 ───────────────────────────────────────────
  { pick: 'Cairo',       key: 'cairo',      ko: '카이로',     country: 'EG', popular: false, open: false },

  // ─── 🇧🇷 브라질 ───────────────────────────────────────────
  { pick: 'Sao Paulo',   key: 'saopaulo',   ko: '상파울루',   country: 'BR', popular: false, open: false },
  { pick: 'Rio de Janeiro', key: 'rio',     ko: '리우데자네이루', country: 'BR', popular: false, open: false },

  // ─── 🇲🇽 멕시코 ───────────────────────────────────────────
  { pick: 'Mexico City', key: 'mexicocity', ko: '멕시코시티', country: 'MX', popular: false, open: false },
  { pick: 'Cancun',      key: 'cancun',     ko: '칸쿤',       country: 'MX', popular: false, open: false },

  // ─── 🇦🇷 아르헨티나 ───────────────────────────────────────────
  { pick: 'Buenos Aires', key: 'buenosaires', ko: '부에노스아이레스', country: 'AR', popular: false, open: false },

  // ─── 🇨🇱 칠레 ───────────────────────────────────────────
  { pick: 'Santiago',    key: 'santiago',   ko: '산티아고',   country: 'CL', popular: false, open: false },
];

const FLAG = {
  VN: '🇻🇳', KR: '🇰🇷', JP: '🇯🇵', CN: '🇨🇳', TW: '🇹🇼',
  TH: '🇹🇭', PH: '🇵🇭', ID: '🇮🇩', MY: '🇲🇾', SG: '🇸🇬',
  AE: '🇦🇪', SA: '🇸🇦', QA: '🇶🇦', KW: '🇰🇼', BH: '🇧🇭', OM: '🇴🇲',
  RU: '🇷🇺', KZ: '🇰🇿', UZ: '🇺🇿', MN: '🇲🇳',
  IN: '🇮🇳', NP: '🇳🇵', LK: '🇱🇰', KH: '🇰🇭', MM: '🇲🇲',
  AU: '🇦🇺', NZ: '🇳🇿',
  US: '🇺🇸', GU: '🇬🇺', MP: '🇲🇵', CA: '🇨🇦',
  GB: '🇬🇧', DE: '🇩🇪', FR: '🇫🇷', NL: '🇳🇱',
  ES: '🇪🇸', IT: '🇮🇹', PT: '🇵🇹', PL: '🇵🇱', CZ: '🇨🇿', TR: '🇹🇷',
  ZA: '🇿🇦', EG: '🇪🇬',
  BR: '🇧🇷', MX: '🇲🇽', AR: '🇦🇷', CL: '🇨🇱',
};

/** Country rows for LocationSelect (order = UX order) */
export const REGION_COUNTRY_ORDER = [
  // 동남아
  'VN', 'TH', 'PH', 'ID', 'MY', 'SG', 'KH', 'MM',
  // 동북아
  'KR', 'JP', 'CN', 'TW', 'MN',
  // 중앙아/러시아
  'RU', 'KZ', 'UZ',
  // 남아시아
  'IN', 'NP', 'LK',
  // 중동
  'AE', 'SA', 'QA', 'KW', 'BH', 'OM',
  // 오세아니아
  'AU', 'NZ',
  // 태평양
  'GU', 'MP',
  // 북미
  'US', 'CA',
  // 유럽
  'GB', 'DE', 'FR', 'NL', 'ES', 'IT', 'PT', 'PL', 'CZ', 'TR',
  // 아프리카
  'ZA', 'EG',
  // 중남미
  'BR', 'MX', 'AR', 'CL',
];

export const LOCATION_COUNTRIES = REGION_COUNTRY_ORDER.map((code) => ({
  code,
  flag: FLAG[code] || '🌍',
  cities: REGION_CITY_ROWS.filter((r) => r.country === code).map((r) => r.pick),
}));

export const REGION_GROUPS = LOCATION_COUNTRIES.map((c) => ({
  code: c.code,
  flag: c.flag,
  cities: c.cities,
}));

export const REGION_BY_PICK = Object.fromEntries(REGION_CITY_ROWS.map((r) => [r.pick, r]));

export const POPULAR_PICKS = REGION_CITY_ROWS.filter((r) => r.popular).map((r) => r.pick);

/** @param {string} pick */
export function catalogRowForPick(pick) {
  return REGION_BY_PICK[pick] || null;
}

/** @param {string} q trimmed lower */
export function filterCitiesByQuery(countryCode, q) {
  const needle = (q || '').trim().toLowerCase();
  const rows = REGION_CITY_ROWS.filter((r) => r.country === countryCode);
  if (!needle) return rows;
  return rows.filter((r) => {
    const en = r.pick.toLowerCase();
    const ko = (r.ko || '').toLowerCase();
    return en.includes(needle) || ko.includes(needle);
  });
}
